import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule, Routes, CanActivate } from '@angular/router';
import { LoginComponent } from './shared/login/login.component';
import { VerifyAccountComponent } from './shared/verify-account/verify-account.component';
import { ResetComponent } from './shared/reset/reset.component';
import { AuthenticatedGuard } from './state/guard/authenticated-guard';
import { PanelTypeGuard } from './core/service/panel-type-guard';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'verify-account',
    component: VerifyAccountComponent
  },
  {
    path: 'reset',
    component: ResetComponent
  },
  {
    path: 'ecommerce',
    loadChildren: './ecommerce/ecommerce.module#EcommerceModule',
    canActivate: [AuthenticatedGuard],
  },
  {
    path: 'shop',
    loadChildren: './panel-shop/panel-shop.module#PanelShopModule',
    canActivate: [AuthenticatedGuard, PanelTypeGuard],
  },
  {
    path: 'admin',
    loadChildren: './panel-admin/panel-admin.module#PanelAdminModule',
    canActivate: [AuthenticatedGuard, PanelTypeGuard],
  },
  {
    path: 'cover',
    loadChildren: './panel-covercare/panel-covercare.module#PanelCovercareModule',
    canActivate: [AuthenticatedGuard, PanelTypeGuard],
  },
  {
    path: 'agent',
    loadChildren: './panel-agent/panel-agent.module#PanelAgentModule',
    canActivate: [AuthenticatedGuard, PanelTypeGuard],
  },
  {
    path: 'mshp',
    loadChildren: './shop-master/shop-master.module#ShopMasterModule',
    canActivate: [AuthenticatedGuard, PanelTypeGuard],
  },
  {
    path: 'lab',
    loadChildren: './panel-lab/panel-lab.module#PanelLabModule',
    canActivate: [AuthenticatedGuard, PanelTypeGuard],
  },
  {
    path: 'client',
    loadChildren: './panel-cli/panel-cli.module#PanelCliModule',
    canActivate: [AuthenticatedGuard, PanelTypeGuard],
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'login',
  }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: false });

@NgModule({
  imports: [routing],
  exports: [RouterModule]
})
export class RoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/routing.module.ts